import React from "react"

import Tags from "../../../common/tags/Tags"
import TagItem from "../../../common/tags/TagItem"
import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"

const UserViewRelatedPanelWidget = ({
    permission_groups,
    topics_followed,
    communities_followed,
    communities_member_of,
    isFetching
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-insights" />Permission groups
            </h3>
            <ContentLoaderTags isFetching={isFetching} minLines={1} maxLines={3}>
                {permission_groups && permission_groups.length > 0 ? (
                    <Tags>
                        {permission_groups.map(group => (
                            <TagItem key={group.id} isGrey={true}>
                                {group.id}
                            </TagItem>
                        ))}
                    </Tags>
                ) : (
                    <p>No permission groups</p>
                )}
            </ContentLoaderTags>
            <h3>
                <i className="icon icon-insights" />Topics followed
            </h3>
            <ContentLoaderTags
                isFetching={isFetching}
                minLines={1}
                maxLines={5}
            >
                {topics_followed && topics_followed.length > 0 ? (
                    <Tags>
                        {topics_followed.map(topic => (
                            <TagItem key={topic.id} isGrey={true}>
                                {topic.name}
                            </TagItem>
                        ))}
                    </Tags>
                ) : (
                    <p>No topics followed</p>
                )}
            </ContentLoaderTags>
            <h3>
                <i className="icon icon-insights" />Communities followed
            </h3>
            <ContentLoaderTags
                isFetching={isFetching}
                minLines={1}
                maxLines={5}
            >
                {communities_followed && communities_followed.length > 0 ? (
                    <Tags>
                        {communities_followed.map(community => (
                            <TagItem key={community.id} isGrey={true}>
                                {community.name}
                            </TagItem>
                        ))}
                    </Tags>
                ) : (
                    <p>No communities followed</p>
                )}
            </ContentLoaderTags>
            <h3>
                <i className="icon icon-community" />Member of
            </h3>
            <ContentLoaderTags
                isFetching={isFetching}
                minLines={1}
                maxLines={5}
            >
                {communities_member_of && communities_member_of.length > 0 ? (
                    <Tags>
                        {communities_member_of.map(community => (
                            <TagItem key={community.id} isGrey={true}>
                                {community.name}
                            </TagItem>
                        ))}
                    </Tags>
                ) : (
                    <p>Not a member of any communities</p>
                )}
            </ContentLoaderTags>
        </div>
    </div>
)

export default UserViewRelatedPanelWidget
